export default __webpack_public_path__ + "static/benifitImage1-8739b1283dc076ac17aa3aa9335e4230.png";